import { render, staticRenderFns } from "./CvLinkIcon.vue?vue&type=template&id=4078b723&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4078b723')) {
      api.createRecord('4078b723', component.options)
    } else {
      api.reload('4078b723', component.options)
    }
    module.hot.accept("./CvLinkIcon.vue?vue&type=template&id=4078b723&", function () {
      api.rerender('4078b723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/icons/CvLinkIcon.vue"
export default component.exports